import React, { useEffect, useRef, useState } from "react";
import dots from "../../assets/HomePage/image 3011.svg";
import star from "../../assets/HomePage/Star 7.svg";
import lines from "../../assets/HomePage/Group 13.svg";
import layer2Img from "../../assets/HomePage/Group 3845.svg";
import layer5Img from "../../assets/HomePage/layer5Image.svg";
import borderImg from "../../assets/HomePage/Group 1000008452.png";
import layer6Img1 from "../../assets/HomePage/Group 17.svg";
import layer6Img2 from "../../assets/HomePage/Group 18.svg";
import arrow from "../../assets/HomePage/image 3022.svg";
import image1 from "../../assets/HomePage/image (1).svg";
import image2 from "../../assets/HomePage/image.svg";
import mixedArrows from "../../assets/HomePage/image 3013.svg";
// import rupee from "../../assets/HomePage/";
import "./HomePage.css";
import { IoCheckmark } from "react-icons/io5";
import Footer from "../../Components/Footer/Footer";
import Slider from "react-slick";
import layer4Img1 from "../../assets/HomePage/Group 1000008488 (1).png";
import layer4Img2 from "../../assets/HomePage/348138.webp";
import layer4Img3 from "../../assets/HomePage/70c81a6780ab075b8ded10f4e489f189.jpg";
import layer4Img4 from "../../assets/HomePage/bigstock.webp";
import layer4Img5 from "../../assets/HomePage/shutterstock_376532611-og.jpg";
import layer4Img6 from "../../assets/HomePage/OIP.jpg";
import Typewriter from "typewriter-effect";
import { Link, useNavigate } from "react-router-dom";
import Graphs from "../Graphs/Graphs";
import AutoPlaytext from "../../Components/AutoplayText/AutoPlaytext";
import dashboard from "../../assets/HomePage/Admin Dashboard (1) 1.jpg";
import icon1 from "../../assets/HomePage/icon1.png";
import icon2 from "../../assets/HomePage/icon2.png";
import icon3 from "../../assets/HomePage/icon3.png";
import icon4 from "../../assets/HomePage/icon4.png";
import icon5 from "../../assets/HomePage/icon5.png";
import icon6 from "../../assets/HomePage/icon6.png";
import IconsMovement from "../../Components/IconsMovement/IconMovement";
import Scrolling from "../../Components/Scrolling/Scrolling";

const HomePage = () => {
  const footerFormRef = useRef(null);
  const [rounded, setRounded] = useState([0, 1, 2, 3, 4, 5]);
  const [count, setCount] = useState(0);
  const [customerSatisfaction, setCustomerSatisfaction] = useState(0);
  // const [happyCustomers, setHappyCustomers] = useState(0)
  const [teamGrowth, setTeamGrowth] = useState(0);
  const [expCount, setExpCount] = useState(0);

  useEffect(() => {
    let incrementVal = setInterval(() => {
      setCount((prev) => (prev < 1 ? prev + 1 : prev));
      setTeamGrowth((prev) => (prev < 1 ? prev + 1 : prev));
      setExpCount((prev) => (prev < 30 ? prev + 1 : prev));
    }, 50);

    return () => {
      clearInterval(incrementVal);
    };
  }, []);
  useEffect(() => {
    let incrementVal = setInterval(() => {
      setCustomerSatisfaction((prev) => (prev < 10 ? prev + 1 : prev));
    }, 50);
    return () => {
      clearInterval(incrementVal);
    };
  }, []);
  const [hoveredCard, setHoveredCard] = useState(null);

  const handleMouseEnter = (cardId) => {
    setHoveredCard(cardId);
  };

  const handleMouseLeave = () => {
    setHoveredCard(null);
  };

  const [selectedOption, setSelectedOption] = useState(1); // Track the selected button
  const [description, setDescription] = useState(
    "Unlock the future of business with innovative tools designed to drive change and create new possibilities. Stay ahead of the curve with cutting-edge features that evolve with your needs."
  );
  const descriptions = {
    1: "Unlock the future of business with innovative tools designed to drive change and create new possibilities. Stay ahead of the curve with cutting-edge features that evolve with your needs.",
    2: "Grow without limits. Our platform adapts seamlessly to your business's expanding needs, providing the flexibility to scale effortlessly as your organization evolves.",
    3: "Experience unmatched performance with optimized solutions that accelerate workflows, enhance productivity, and deliver results faster. Power your success with reliability and speed.",
  };

  // Handle button click to update the selected button and description
  const handleButtonClick = (option) => {
    setSelectedOption(option);
    setDescription(descriptions[option]);
  };
  // var settings = {
  //   dots: true,
  //   infinite: true,
  //   speed: 500,
  //   slidesToShow: 1,
  //   slidesToScroll: 1,
  // };

  const [isActive, setIsActive] = useState(false);

  useEffect(() => {
    // Activate the animation when the component mounts
    setIsActive(true);
  }, []);
  const [activeIndex, setActiveIndex] = useState(0);
  const data = [
    {
      image1: icon1,
      image: layer4Img1,
      title: "Business Development",
      heading: "Empower Growth, Unlock Opportunities",
      text: "Drive strategic growth with tools that help identify market opportunities, enhance client relationships, and boost revenue streams. Streamline your business processes and stay ahead of the competition. Achieve sustainable expansion through data-driven insights and targeted strategies. Transform challenges into milestones and accelerate your business growth effortlessly.",
    },
    {
      image1: icon2,
      image: layer4Img2,
      heading: "Turn Ideas into Impactful Campaigns",
      text: "Plan and execute high-impact marketing campaigns that captivate your audience and maximize ROI. Leverage analytics to fine-tune your strategies and make data-driven decisions. Simplify social media management, email campaigns, and outreach, all from one platform. Connect with your audience, build brand loyalty, and drive measurable results.",
      title: "Marketing",
    },
    {
      image1: icon3,
      image: layer4Img3,
      heading: "Transform Your HR, Empower Your Workforce",
      text: "Streamline HR processes like hiring, onboarding, and payroll while fostering a positive work culture. Manage employee performance, compliance, and workforce analytics effortlessly. Equip your teams with the tools to grow and thrive in a supportive environment. Build an empowered workforce that drives your business success.",
      title: "Human Resources",
    },
    {
      image1: icon4,
      image: layer4Img4,
      heading: "Master Your Finances, Maximize Profits!",
      text: "Gain complete control over your finances with tools to manage budgets, track expenses, and generate insightful reports. Simplify billing, invoicing, and cash flow analysis for smarter decision-making. Ensure compliance while minimizing risks with real-time financial data. Drive profitability and financial stability effortlessly.",
      title: "Finance",
    },
    {
      image1: icon5,
      image: layer4Img5,
      heading: "Fuel Growth with High-Quality Leads",
      text: "Capture, track, and nurture leads with advanced tools designed to boost conversions. Prioritize opportunities with lead scoring and insights to focus on what matters most. Automate follow-ups and keep your pipeline flowing with potential clients. Turn prospects into loyal customers and ensure consistent growth.",
      title: "Lead Generation",
    },
    {
      image1: icon6,
      image: layer4Img6,
      heading: "Plan Smarter, Deliver Faster",
      text: "Organize, track, and execute projects efficiently with collaborative tools and detailed dashboards. Manage tasks, timelines, and resources in real-time to meet deadlines with ease. Identify bottlenecks and stay aligned on goals across teams. Deliver projects on time and within budget, every time.",
      title: "Training & Learning",
    },
  ];

  const scrollToFooterForm = () => {
    footerFormRef.current.scrollIntoView({ behavior: "smooth" });
  };
  const navigate = useNavigate();
  const handleNavigate = () => {
    navigate("/Signup");
  };
  const clickTesting = () => {
    console.log("buttonClicked");
  };
  return (
    <div className="home_main_div">
      {/* <Slider {...settings}> */}
      <div className="home_layer1_container">
        <h1 className="home_layer1_title">
          Simplify Your Business Processes with Oraddo
        </h1>
        <div
          className={`home_layer1_separator ${isActive ? "active" : ""}`}
        ></div>
        <p className="home_layer1_description">
          Streamline, Automate, and Elevate Your Operations with Our Cloud Based
          Business Process Management System.
        </p>

        <div className="button-container" onclick={clickTesting}>
          <img src={star} alt="star" className="star_icon_left" />
          <a
            href="https://calendly.com/sandeep-oraddo/30min?back=1&month=2025-01"
            target="_blank"
            rel="noopener noreferrer"
          >
            <button className="request-demo-button">Request a Demo</button>
          </a>
          <img src={lines} alt="lines" className="dot_icon_right" />
        </div>

        <div className="dots-container">
          <img src={dots} alt="dots" className="dots" />
        </div>
      </div>
      {/* </Slider> */}
      {/* <div className="homePage_contactUs_side">
        <h1 onClick={scrollToFooterForm} style={{ cursor: "pointer" }}>
          Contact Us
        </h1>
      </div> */}
      <div className="home_layer2_container" id="layer2">
        <div className="home_layer2_content">
          <div className="home_layer2_image_container">
            {/* <img
              src={layer2Img}
              alt="layer2Img"
              className="home_layer2_layer_image"
            /> */}
            <Graphs />
          </div>
          <div className="home_layer2_text_container">
            <div className="home_layer2_custom_pink_box">
              <p className="home_layer2_solution_text">
                <Typewriter
                  options={{
                    strings: ["Solutions For better SAAS"],
                    autoStart: true,
                    loop: true,
                  }}
                />
              </p>
            </div>
            <div className="home_layer2_heading_container">
              <h1 className="home_layer2_main_heading">
                Smart Spending, High Earnings, Rapid Growth!
              </h1>
            </div>
            {/* <div className="home_layer2_separator"></div> */}
            <div
              className={`home_layer2_separator ${isActive ? "active" : ""}`}
            ></div>
            <div className="home_layer2_content_box">
              <p className="home_layer2_content_text">
                <b> Quick Implementation:</b> Get started faster with easy
                onboarding and user-friendly interfaces.
              </p>
              <p className="home_layer2_content_text">
                <b> Centralized Operations: </b>Manage all your business
                processes from a single, intuitive platform.
              </p>
              <p className="home_layer2_content_text">
                <b> Secure and Scalable:</b> Future-proof your business with
                enterprise-grade security and scalability.
              </p>
            </div>
            <div className="home_layer2_button_container">
              <button
                className="home_layer2_support_button"
                onClick={handleNavigate}
              >
                Sign up Now
              </button>
              <img src={star} alt="star" className="home_layer2_star_icon" />
            </div>
          </div>
        </div>
      </div>
      <div className="home_layer3_container">
        <div className="home_layer3_circle_container">
          {/* {rounded.map((arr, ind) => (
            <div className="home_layer3_circle" key={ind}></div>
          ))} */}
          {/* </div> */}
          {data.map((data, index) => (
            <div
              className="c"
              key={index}
              // Update activeIndex on click
            >
              <div
                className={`home_layer3_circle ${
                  activeIndex === index ? "active-circle" : ""
                }`}
                onMouseOver={() => setActiveIndex(index)}
              >
                <img src={data.image1} alt={data.image1} />
              </div>
              <p>{data.title}</p>
            </div>
          ))}
        </div>

        <img
          src={borderImg}
          alt="borderImg"
          className="home_layer3_border_image"
        />
      </div>

      <div className="home_layer3_circle_container_2">
        <div className="home_layer3_circle_container_2_content">
          <h1> {data[activeIndex].heading}</h1>
          <p> {data[activeIndex].text}</p>
        </div>
      </div>
      <div className="home_layer4_statistics_section">
        <div className="home_layer4_background_gray">
          <img src={layer4Img1} alt="layer4Img1" />
          {/* <div className="layer4_img_top_text">
            <p> Lorem Ipsum is simply dummy text</p> 
             <p>{data[activeIndex].text}</p>
          </div> */}
        </div>
        <div className="home_layer4_dark_blue_section">
          <div className="home_layer4_content_wrapper">
            <div className="home_layer4_text_content">
              <div className="home_layer4_custom_button">
                <p>
                  <Typewriter
                    options={{
                      strings: ["About Oraddo"],
                      autoStart: true,
                      loop: true,
                    }}
                  />
                </p>
              </div>
              <h1 className="home_layer4_heading">
                Empower Your Business with Oraddo
              </h1>
              <p className="home_layer4_description">
                From innovative features that keep you ahead of the competition,
                to scalable tools that grow with your business, and
                high-performance capabilities that accelerate results, our
                platform empowers you to achieve more, faster, and smarter.
              </p>
            </div>
            {/* <div className="home_layer4_interactive_section">
              <div className="home_layer4_switch_buttons">
                <p className="home_layer4_button_option">one</p>
                <p className="home_layer4_button_selected">one</p>
                <p className="home_layer4_button_option">one</p>
              </div>
              <p className="home_layer4_extra_description">
                Lorem Ipsum is simply dummy text of the printing and typesetting
                Lorem Ipsum is simply duLorem Ipsum is simply dum of the
                printing and typesetting Lorem Ip simply dummy Lorem Ipsum is
                simply dummy
              </p>
            </div> */}
            <div className="home_layer4_interactive_section">
              <div className="home_layer4_switch_buttons">
                <p
                  className={`home_layer4_button_option ${
                    selectedOption === 1 ? "home_layer4_button_selected1" : ""
                  }`}
                  onClick={() => handleButtonClick(1)}
                >
                  Innovation
                </p>
                <p
                  className={`home_layer4_button_option ${
                    selectedOption === 2 ? "home_layer4_button_selected2" : ""
                  }`}
                  onClick={() => handleButtonClick(2)}
                >
                  Scalability
                </p>
                <p
                  className={`home_layer4_button_option ${
                    selectedOption === 3 ? "home_layer4_button_selected3" : ""
                  }`}
                  onClick={() => handleButtonClick(3)}
                >
                  Performance
                </p>
              </div>
              <p className="home_layer4_extra_description">{description}</p>
            </div>
          </div>
          <div className="home_layer4_statistics_wrapper">
            <div className="home_layer4_statistic">
              <h1 className="home_layer4_stat_value">{count}M<span>INR</span></h1>
              <p className="home_layer4_stat_label">Save your money per year</p>
            </div>
            <div className="home_layer4_statistic">
              <h1 className="home_layer4_stat_value">~ {teamGrowth}</h1>
              <p className="home_layer4_stat_label">Rocket Speed to use</p>
            </div>
            <div className="home_layer4_statistic">
              <h1 className="home_layer4_stat_value"> {expCount}+</h1>
              <p className="home_layer4_stat_label">
                Team brains used to built
              </p>
            </div>
            <div className="home_layer4_statistic">
              <h1 className="home_layer4_stat_value">
                {" "}
                {customerSatisfaction}M
              </h1>
              <p className="home_layer4_stat_label">
                Hours saved from Manual Operations
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="home_layer5_feature_section" id="layer1">
        <div className="home_layer5_image_container">
          <img
            src={layer5Img}
            alt="layer5Img"
            className="home_layer5_feature_image"
          />
        </div>
        <div className="home_layer5_content_container">
          <div className="home_layer5_feature_label">
            <p className="home_layer5_label_text">
              <Typewriter
                options={{
                  strings: ["Simply your business"],
                  autoStart: true,
                  loop: true,
                }}
              />
            </p>
          </div>
          <div>
            <h1 className="home_layer5_feature_title">
              Unlock Efficiency, Drive Growth
            </h1>
          </div>
          <div className="home_layer5_feature_description">
            <p>
              Transform complex workflows into seamless operations with our
              intuitive platform. From automation to real-time insights,
              streamline every aspect of your business and focus on what drives
              growth.
            </p>
          </div>
          <div className="home_layer5_demo_button_container">
            <img src={star} alt="star" className="home_layer5_star_icon" />
            <a
              href="https://calendly.com/sandeep-oraddo/30min?back=1&month=2025-01"
              target="_blank"
              rel="noopener noreferrer"
            >
              <button className="home_layer5_demo_button">
                Request a Demo
              </button>
            </a>
          </div>
          <div className="home_layer5_feature_list">
            <div className="home_layer5_list_column">
              <p className="home_layer5_list_item">
                <span className="home_layer5_checkmark">
                  <IoCheckmark />
                </span>{" "}
                Invoice Management
              </p>
              <p className="home_layer5_list_item">
                <span className="home_layer5_checkmark">
                  <IoCheckmark />
                </span>{" "}
                Chat Management
              </p>
            </div>
            <div className="home_layer5_list_column">
              <p className="home_layer5_list_item">
                <span className="home_layer5_checkmark">
                  <IoCheckmark />
                </span>{" "}
                HR Process
              </p>
              <p className="home_layer5_list_item">
                <span className="home_layer5_checkmark">
                  <IoCheckmark />
                </span>{" "}
                Lead Generation
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="home_layer6_support_section">
        <div className="home_layer6_image_container">
          <img
            src={layer6Img1}
            alt="Support Image 1"
            className="home_layer6_support_image1"
          />
        </div>
        <div className="home_layer6_content_container">
          <div className="home_layer6_support_label">
            <p className="home_layer6_label_text">
              <Typewriter
                options={{
                  strings: ["Trusted Partner Support"],
                  autoStart: true,
                  loop: true,
                }}
              />
            </p>
          </div>
          <h1 className="home_layer6_support_title">
            Dedicated Support at Every Step
          </h1>
          <div className="home_layer6_support_details">
            <div className="home_layer6_dotted_line"></div>
            <p className="home_layer6_support_point">
              <span className="home_layer6_circle_indicator"></span>
              <b>24/7 Availability:</b>Get assistance anytime, anywhere with
              round-the-clock support to resolve issues quickly.
            </p>
            <p className="home_layer6_support_point">
              <span className="home_layer6_circle_indicator"></span>
              <b>Multi-Channel Support:</b> Reach out via Whatsapp, Email, or
              Phone for the help you need, when you need it.
            </p>
            <p className="home_layer6_support_point">
              <span className="home_layer6_circle_indicator"></span>
              <b> Expert Guidance:</b> Our knowledgeable support team is here to
              provide expert solutions and ensure your experience is seamless.
            </p>
          </div>
        </div>
        <div className="home_layer6_image_container">
          <img
            src={layer6Img2}
            alt="Support Image 2"
            className="home_layer6_support_image1"
          />
        </div>
      </div>

      <div className="howe_layer6_section2_outer">
        <div className="home_layer6_section2_heading">
          <h1>Hassle free no-cost onboarding & Support</h1>
        </div>
        <div className="home_layer_autoplay_text">
          <AutoPlaytext />
        </div>
      </div>
      <div className="home_iconMovement">
        <IconsMovement />
      </div>
      <div className="home_layer7_features_section" id="layer3">
        <div className="home_layer7_content_wrapper">
          <div className="home_layer7_content">
            <div className="home_layer7_features_wrapper">
              <div className="home_layer7_feature_label">
                <p className="home_layer7_label_text">
                  <Typewriter
                    options={{
                      strings: ["Cost Effective"],
                      autoStart: true,
                      loop: true,
                    }}
                  />
                </p>
              </div>
              <h1 className="home_layer7_feature_title">
                Affordable Plans Designed for Your Growth
              </h1>
              <p className="home_layer7_feature_description">
                Tailored pricing plans to fit your business needs, no matter the
                size. Experience powerful features at a cost that ensures your
                success without breaking the bank.
              </p>
              <div className="home_layer7_demo_button_wrapper">
                <img src={star} alt="star" className="home_layer7_star_icon" />
                <Link to="/Pricing">
                  <button className="home_layer7_demo_button">Our Plans</button>
                </Link>
              </div>
            </div>
            {/* <div className="home_layer7_pricing_card">
              <div className="home_layer7_original_price">
                <h1 className="home_layer7_price_strike">5000 /-</h1>
                <p className="home_layer7_price_text">Per Month</p>
              </div>
              <div className="home_layer7_pricing_divider"></div>
              <div className="home_layer7_discount_price">
                <p className="home_layer7_discount_text">@ Just</p>
                <h1 className="home_layer7_final_price">3500 /-</h1>
              </div>
            </div> */}
          </div>
        </div>
        <div className="home_layer7_image_container">
          <div className="home_layer7_background_box">
            <img src={dashboard} alt="dashboard" />
          </div>
        </div>
      </div>
      {/* <div className="main_container_section">
        <div className="top_first_container">
          <div className="top_first_container_h1">
            <h2 className="top_first_container_h2_tag">
              <Typewriter
                options={{
                  strings: ["Know more Our essence"],
                  autoStart: true,
                  loop: true,
                }}
              />
            </h2>
          </div>
          <p className="top_first_container_p_tag">
            Lorem Ipsum is simply dummy text of the printing
          </p>
          <div
            className={`top_first_container_border ${isActive ? "active" : ""}`}
          ></div>
        </div>
        <div className="bottom_main_container">
          <div className="left_bottom_container">
            <div className="bottom_second_container">
              <h2 className="bottom_second_h2_tag">100 %</h2>
              <p className="bottom_content_tag">Customer Satisfaction</p>
            </div>

            <div className="bottom_second_container">
              <h2 className="bottom_second_h2_tag">43</h2>
              <p className="bottom_content_tag">Customer Satisfaction</p>
            </div>

            <div className="bottom_second_container">
              <h2 className="bottom_second_h2_tag">79 %</h2>
              <p className="bottom_content_tag">Customer Satisfaction</p>
            </div>
          </div>
          <div className="home_layer8_arrow_img">
            <img src={arrow} alt="arrow" />
          </div>
          <div className="right_bottom_container">
            {[1, 2, 3].map((cardId) => (
              <div
                key={cardId}
                className="card"
                onMouseEnter={() => handleMouseEnter(cardId)}
                onMouseLeave={handleMouseLeave}
              >
                {hoveredCard === cardId ? (
                  <div className="right_bottom_card_1">
                    <img
                      src={image1}
                      alt="image1"
                      className="card_bottom_image_1"
                    />
                    <h2 className="card_bottom_h2_tag_1">
                      Lorem Ipsum is simply
                    </h2>
                    <p className="card_bottom_p_tag_1">
                      Lorem Ipsum is simply dummy text of the printing and
                      typesetting Lorem Ipsum is simply dummy and typesetting
                      Lorem Ipsum is simply dummy
                    </p>
                    <div className="mixedArrows">
                      <img src={mixedArrows} alt="mixedArrows" />
                    </div>
                  </div>
                ) : (
                  <div className="right_bottom_card_2">
                    <img
                      src={image2}
                      alt="image2"
                      className="card_bottom_image_2"
                    />
                    <h2 className="card_bottom_h2_tag_2">
                      Lorem Ipsum is simply
                    </h2>
                    <div className="mixedArrows1">
                      <img src={mixedArrows} alt="mixedArrows" />
                    </div>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div> */}
      <div className="home_footer" ref={footerFormRef}>
        <Footer />
      </div>
      <Scrolling />
    </div>
  );
};

export default HomePage;
